import { useEffect } from 'react';
import { captureStore, PlayerAccessRights } from './store';
import { useAnimationFrame } from '../useAnimationFrame';

declare global {
  interface Navigator {
    keyboard: { lock: () => Promise<undefined> }; // Replace 'any' with the type of 'keyboard' if known
  }
}

export const useGamepads = (enabled: boolean, callback: (event: Event) => void) => {
  useAnimationFrame((t: number) => {
    if (!enabled) return;
    const g = navigator.getGamepads();
    // Convert the gamepad info above into the right format to be an "event"
    const event = new CustomEvent('gamepad', {
      detail: g,
    });
    callback(event);
  });
};

// skipGamepad is used to prevent physical gamepad input when we are using the mobile gamepad
export const Input = (props: PlayerAccessRights & { skipGamepad?: boolean }) => {
  const { mouse, keyboard, touch, gamepad, skipGamepad } = props;

  const callback = (event: Event | CustomEvent) => {
    captureStore.addEvent(event);
    event.preventDefault();
  };

  useGamepads(
    !!gamepad,
    skipGamepad
      ? () => {
          return;
        }
      : callback,
  );

  const mouseEvents = ['mousedown', 'mouseup', 'mousemove', 'wheel'];
  const keyboardEvents = ['keydown', 'keyup'];
  const touchEvents = ['touchstart', 'touchend', 'touchmove', 'touchcancel'];
  const gamepadEvents = ['gamepad'];

  const eventTypes: string[] = [];
  if (mouse) {
    eventTypes.push(...mouseEvents);
  }
  if (keyboard) {
    eventTypes.push(...keyboardEvents);
  }
  if (touch) {
    eventTypes.push(...touchEvents);
  }
  if (gamepad) {
    eventTypes.push(...gamepadEvents);
  }

  useEffect(() => {
    console.log('InputCapture: add captured events', eventTypes);
    eventTypes.forEach((e) => {
      window.addEventListener(e, callback as EventListener, { passive: false });
    });
    return () => {
      console.log('InputCapture: remove captured events');
      eventTypes.forEach((e) => {
        window.removeEventListener(e, callback as EventListener);
      });
    };
  });

  return null;
};
